var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 18,
    viewBox: "0 0 38 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 18,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 18,
    rx: 6,
    fill: "#FF4A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8834 10.976H8.95136V14H7.41536V5.228H10.8834C12.6474 5.228 13.7874 6.38 13.7874 8.096C13.7874 9.788 12.6354 10.976 10.8834 10.976ZM10.5834 6.596H8.95136V9.608H10.5594C11.6154 9.608 12.1794 9.044 12.1794 8.084C12.1794 7.124 11.6034 6.596 10.5834 6.596ZM16.6154 14H15.0794V5.228H18.4274C20.4194 5.228 21.5834 6.236 21.5834 7.964C21.5834 9.14 21.0314 9.98 19.9994 10.4L21.6674 14H19.9874L18.4994 10.724H16.6154V14ZM16.6154 6.596V9.368H18.4274C19.3994 9.368 19.9754 8.852 19.9754 7.964C19.9754 7.088 19.3994 6.596 18.4274 6.596H16.6154ZM31.099 9.608C31.099 12.272 29.347 14.144 26.827 14.144C24.319 14.144 22.591 12.284 22.591 9.608C22.591 6.944 24.331 5.072 26.839 5.072C29.347 5.072 31.099 6.932 31.099 9.608ZM29.479 9.608C29.479 7.736 28.447 6.548 26.839 6.548C25.231 6.548 24.199 7.736 24.199 9.608C24.199 11.48 25.231 12.668 26.839 12.668C28.447 12.668 29.479 11.456 29.479 9.608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.bf4cea6b6373189f7e1458be208a3cd0.svg";
export { ForwardRef as ReactComponent };